import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { ActivityFindInterface } from '@zaoblako/shared/modules/finance/dtos/activity/activity-find.dto';
import { TypeOfActivityService } from '@zaoblako/web/core/services/ofd/type-of-activity.service';
import { GlobalService } from '@zaoblako/web/core/services/global.service';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';

@Component({
  selector: 'crm-activity-single-select',
  standalone: true,
  imports: [CommonModule, SingleSelectComponent],
  templateUrl: './activity-single-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActivitySingleSelectComponent implements OnInit {
  @Input() public activities: ActivityFindInterface[] = [];
  public loading = false;

  @Input() public selectedActivity: ActivityFindInterface;
  @Output() public selectedActivityChange = new EventEmitter<ActivityFindInterface>();

  @Output() public changeValue = new EventEmitter<ActivityFindInterface>();

  @Input() public customRequest = false;
  @Input() public class: string;
  @Input() public styleClass: string;
  @Input() public showClear = false;
  @Input() public disabled = false;
  @Input() public isError = false;
  @Input() public appendTo: string;

  public constructor(
    private readonly typeOfActivityService: TypeOfActivityService,
    private readonly globalService: GlobalService,
    private readonly cdRef: ChangeDetectorRef
  ) {}

  public ngOnInit(): void {
    if (
      !this.customRequest &&
      this.globalService.globalInfo.tenantInfo?.ratePlan?.modulesAccessControl?.BASIS?.enabled
    ) {
      this.loading = true;
      this.typeOfActivityService.findAll().subscribe({
        next: (activities: ActivityFindInterface[]) => {
          this.activities = activities;
          this.loading = false;
          this.cdRef.markForCheck();
        },
        error: () => {
          this.loading = false;
          this.cdRef.markForCheck();
        }
      });
    }
  }
}
